//import { refreshToken } from 'appRedux/actions/Auth';

import {
  userSignOut
} from "./Auth"


const setupAxiosInterceptors = (request, dispatch, getState) => {
  
  request.interceptors.request.use(
    config => {
      const {access_token, expires_in} = getState().auth;
      if (access_token) {
        config.headers['Authorization'] = access_token;
      }
      if (expires_in) {
        config.headers['Expires'] = expires_in;
      }
      return config;
    },
    error => {
        Promise.reject(error)
    }
  );

  request.interceptors.response.use(
    response => response,
    (error, m) => {
      //dispatch(refreshToken());
      if(error.response.status === 401){
        dispatch(userSignOut())
      }
      
      localStorage.clear();

      return Promise.reject(error)
    }
  )

  return request;
};

export default setupAxiosInterceptors;